module.exports = __webpack_public_path__ + "static/media/27.29aa6da9.png";